import React, { use, useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";

import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Loader from '../../components/loader';

function LedgerReport() {

    const [loader, setLoader] = useState(false);
    const [orderData, setData] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [date, setDate] = useState(today);
    const [itemData, setItemData] = useState([]);

    const formatDate = (date) => {     
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const getData = async () => {
        setLoader(true);
        try {
            const response = await axios.post('https://api.trucoo.in/invoice/report/', {date}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            
            console.log(response.data);
    
            if (response.data.status === "success") {
                setData(response.data.data);
            } else {
                console.log("Error fetching data");
                setData([]); 
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
            setData([]); 
        }
        setLoader(false);
    };

    useEffect(() => {
        getData();
    }, [date]);
    

    const getItems = () => {
    const itemsData = [];

    orderData?.forEach(order => {
        order?.orderData?.forEach(item => {

        const discountArray = order?.discountData ? JSON.parse(order.discountData) : [];
        const dis = discountArray.filter(discItem => discItem?.item === item?.itemId);

        let disCrates = 0;

        if(dis.length > 0){
            if(dis[0]?.type === 'grade' && dis[0]?.discount === 'packet'){
                disCrates = (parseFloat(dis[0]?.value) * parseFloat(item?.qty)) / parseFloat(item?.itemGrade);
            }

            if(dis[0]?.type === 'liters' && dis[0]?.discount === 'packet'){
                const ltr =  parseFloat(item?.qty) * (parseFloat(item?.itemWeight)/1000);
                const pkt = ltr * parseFloat(dis[0]?.value);
                disCrates = pkt / parseFloat(item?.itemGrade);
            }

            if(dis[0]?.type === 'packet' && dis[0]?.discount === 'packet'){
                const pkt = parseFloat(item?.qty) * parseFloat(item?.itemGrade);
                disCrates = pkt / parseFloat(item?.itemGrade);
            }
        }

        const crates = parseFloat(item?.qty) + parseFloat(disCrates);
        const existingItem = itemsData.find(i => i.id === item?.itemId);

        if (existingItem) {
            // Add qty if item already exists
            existingItem.qty += parseFloat(crates);
        } else {
            // Add new item if it doesn't exist
            itemsData.push({
                id: item?.itemId,
                qty: parseFloat(crates),
                crates: item?.itemGrade,
                price: item?.itemPrice,
                weight: item?.itemWeight,
                item: item?.itemName
            });
        }
        });
    });

    return itemsData;
    };

    useEffect(() => {
        const itemsData = getItems();
        setItemData(itemsData);
    },[orderData]);

    const exportToExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Daily Sales Report');
        XLSX.writeFile(wb, `Daily_Items_Report_${formatDate(date)}.xlsx`);
    };

    let totalCrates = 0;
    let totalPackets = 0;
    let totalWeight = 0;
    let totalAmount = 0;

    return (
        <>
            {loader && <Loader /> }
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                 <div className="row" >
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" >
                                        <h4 className="box-title">Daily Sales Report</h4>
                                        <p className="mb-0 box-subtitle">Invoices</p>   
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" ></div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" ></div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" ></div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="right">
                                        <input
                                            type="date"
                                            value={formatDate(date)}
                                            onChange={(e) => setDate(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="right">
                                        <button className="btn btn-sm btn-success" onClick={exportToExcel}><i className="fa fa-download"></i> Excel</button>
                                    </div>
                                </div>
                            </div>
                           
                    
                            <div className="box-body">
                                <div className="table-responsive" style={{width: '100%', height: '65vh', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                        <thead>
                                            <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th width="3%">S.No</th>
                                                <th>Item</th>
                                                <th width="10%">Crates</th>
                                                <th width="10%">Packets</th>
                                                <th width="10%">LTR/KG</th>
                                                <th width="10%">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderData?.length > 0 ? (
                                                <>
                                                {
                                                itemData.map((item, index) => {

                                                    const crates = parseFloat(item?.qty);
                                                    const packets = crates * parseFloat(item?.crates);
                                                    const weight = packets * (parseFloat(item?.weight)/1000);
                                                    const amount = packets * parseFloat(item?.price);
                                                    
                                                    totalCrates += crates;
                                                    totalPackets += packets;
                                                    totalWeight += weight;
                                                    totalAmount += amount;

                                                    return (
                                                    <tr key={index}>
                                                        <td className="text-center">{index+1}</td>
                                                        <td>{item?.item}</td>
                                                        <td className="text-end">{Number(crates).toFixed(2)}</td>
                                                        <td className="text-end">{Number(packets).toFixed(2)}</td>
                                                        <td className="text-end">{Number(weight).toFixed(2)}</td>
                                                        <td className="text-end">{Number(amount).toFixed(2)}</td>
                                                    </tr>
                                                    )})}

                                                    <tr class="fs-12">
                                                       <th colSpan={2}>Total</th>
                                                       <th className="text-end">{Number(totalCrates).toFixed(2)}</th>
                                                       <th className="text-end">{Number(totalPackets).toFixed(2)}</th>
                                                       <th className="text-end">{Number(totalWeight).toFixed(2)}</th>
                                                       <th className="text-end">{Number(totalAmount).toFixed(2)}</th>
                                                    </tr>
                                                    </>

                                                        ) : (
                                                        <tr>
                                                            <td colSpan="17" className="text-center">No Data Available</td>
                                                        </tr>
                                                    )}
                                       </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {/* <Footer /> */}
        </>
    );
}

export default LedgerReport;